__turbopack_context__.v({
  "errorBoundary": "styles-module-scss-module__WVWxCG__errorBoundary",
  "errorBoundary__message": "styles-module-scss-module__WVWxCG__errorBoundary__message",
  "errorBoundary__message_error": "styles-module-scss-module__WVWxCG__errorBoundary__message_error",
});
